import { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { getIsMobile } from '../utils/product-bundle-utils';

const useDeviceType = () => {
  const experienceContext = useContext(ExperienceContext);
  const { channel, isConsumerApp } = experienceContext || {};
  const isMobile = getIsMobile(channel);
  return {
    isMobile,
    channel,
    isConsumerApp
  };
};

export default useDeviceType;